import { styled } from "@mui/material";
import React from "react";

const PLACEHOLDER_IMAGE =
  "https://www.psw.com.au/media/catalog/product/placeholder/default/Image-Coming-Soon.png";

const ImageComponent = ({ imageUrl, alt }) => {
  const ProductDiv = styled("div")(({ theme }) => ({
    position: "relative",
    height: "75px",
    width: "75px",

    "& img": {
      height: "75px !important",
      width: "75px !important",
      objectFit: "contain !important",
      position: "absolute",
      top: "-30px",
      left: "0",
    },
  }));

  return (
    <ProductDiv>
      <img src={imageUrl || PLACEHOLDER_IMAGE} alt={alt} />
    </ProductDiv>
  );
};

export default ImageComponent;
